/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';

export interface ApiMasterTagGetAllGet$Params {
}

export function apiMasterTagGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterTagGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTagGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Tag>>;
    })
  );
}

apiMasterTagGetAllGet.PATH = '/api/Master/Tag/GetAll';
